import type { MessageResponse } from 'stream-chat';

const map = new WeakMap<object, MessageResponse>();

export const setSearchMessage = (channel: object, message: MessageResponse): void => {
  map.set(channel, message);
};

export const getSearchMessage = (channel: object): MessageResponse | undefined => map.get(channel);
